/**
 * Cleans HTML text by removing HTML tags and decoding HTML entities
 * @param {string} htmlText - The HTML text to clean
 * @returns {string} - The cleaned text
 */
export const cleanHtmlText = (htmlText) => {
  if (!htmlText) return "";

  // Remove leading and trailing newlines, then remove HTML tags
  const withoutTags = htmlText
    .replace(/^[\n]+|[\n]+$/g, "")
    .replace(/<[^>]*>/g, "");

  // Decode HTML entities
  const textarea = document.createElement("textarea");
  textarea.innerHTML = withoutTags;
  return textarea.value;
};

export default cleanHtmlText;
